import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import LazyLoad from 'react-lazyload';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTag, faChevronRight, faLink } from '@fortawesome/pro-solid-svg-icons';

import Loader from '../../Loader/Loader';
import { getSmartImage, dismissEvent } from '../../../Helpers/helpers';
import { getAffiliateLink } from '../../../Helpers/attribution_helpers';
import { getPrettyPriceDisplay } from '../../../Helpers/formatting';

const CollectionProductCompact = props => {
  const {
    user,
    collection,
    pin,
    code,
    copyCode,
    lastLocation,
    canEdit,
    DragHandle,
    navigateToProduct,
    showingActionsPanel,
    getActionsPanel,
    updateLinkRefAttributes,
    copyLink,
    toggleEditMode
  } = props;
  const { title, description, image, isHidden } = pin;
  const affiliateLink = getAffiliateLink(pin, user, collection.user, collection);

  return (
    <div className={cn('collection-product compact', { hidden: isHidden, 'hide-over-sm': props.isMobileOnly })}>
      <a
        ref={ref => ref && updateLinkRefAttributes(ref)}
        href={affiliateLink}
        target='_blank'
        rel='nofollow noopener noreferrer'
        className={cn('collection-product-img-wrapper', {
          smooth: !canEdit && !!lastLocation
        })}
      >
        {!!isHidden && (
          <div className='hidden-cover'>
            <div className='badge'>HIDDEN</div>
          </div>
        )}
        <LazyLoad height={200} offset={window.__IS_SNAP__ ? 2000 : 480}>
          <img
            alt={title || 'Product'}
            onClick={navigateToProduct}
            className={cn('product-image', image ? '' : 'empty')}
            src={getSmartImage(image)}
          />
        </LazyLoad>
      </a>
      <div className='meta-container'>
        {canEdit && (
          <div className='action-btn-container'>
            {!showingActionsPanel && <FontAwesomeIcon onClick={copyLink} icon={faLink} />}
            {!showingActionsPanel && <FontAwesomeIcon onClick={toggleEditMode} icon={faPencilAlt} />}
            {getActionsPanel()}
          </div>
        )}
        <a
          ref={ref => ref && updateLinkRefAttributes(ref)}
          href={affiliateLink}
          target='_blank'
          rel='nofollow noopener noreferrer'
          onClick={navigateToProduct}
        >
          <h3 className='header'>{title}</h3>
          {description && <h4 className='description'>{description}</h4>}
          {code && !!pin.allow_displaying_codes && (
            <div onClick={dismissEvent} className='code-container'>
              <FontAwesomeIcon onClick={copyCode} icon={faTag} />
              <div onClick={copyCode} className='code'>
                USE CODE <span className='display'>{code.displayText}</span> FOR{' '}
                {code.isPercentage ? `${code.rate}% OFF` : `${getPrettyPriceDisplay(code.rate)} OFF`}
              </div>
            </div>
          )}
          <div className='link-to-product'>
            SHOP NOW
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </a>
        {canEdit && <DragHandle />}
      </div>
      {(props.isDeleting || props.isBeingEdited || props.isDuplicating) && (
        <div className='adjusting-product-loader active'>
          <Loader size={100} />
        </div>
      )}
    </div>
  );
};

CollectionProductCompact.propTypes = {
  // Main Data
  user: PropTypes.object.isRequired,
  collection: PropTypes.object.isRequired,
  pin: PropTypes.object.isRequired,
  lastLocation: PropTypes.object,

  // Variables
  index: PropTypes.number.isRequired,
  canEdit: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool,
  isDuplicating: PropTypes.bool,
  isBeingEdited: PropTypes.bool,
  showingActionsPanel: PropTypes.bool,

  // Functions
  navigateToProduct: PropTypes.func.isRequired,
  updateLinkRefAttributes: PropTypes.func.isRequired,
  copyLink: PropTypes.func.isRequired,
  toggleEditMode: PropTypes.func.isRequired,
  DragHandle: PropTypes.func
};

export default CollectionProductCompact;
